/* eslint-disable max-len */

import React, {useEffect} from 'react';

import {
  FiWifiOff
} from 'react-icons/fi';


import styles from './NoInternet.module.css';

export default function NoInternet({set}) {

  useEffect(()=>{
    set(true);
  },[])
  

  return (
    <div className={styles.container}>
      <section className={styles.banner}>
        <h2>Infelizmente parece que você está sem conexão com a internet.</h2>
      </section>
      
      <section className={styles.error_message}>
        <div className={styles.image_people}>
            <FiWifiOff size={100} color='#df9646'/>
          </div>
        <p>Verifique seu Wi-Fi ou rede de dados, ao reconectar você será redirecionado a página.</p>
      </section>
    </div>
  );
}
